<template>
  <div style="padding-top: 40px">
    <div>
      <p class="navadno-besedilo" style="padding-bottom: 5px;">
        Na tej strani lahko urejate svoje brezžično omrežje. Nastavite lahko ime omrežja, geslo (ključ)
        in ostale nastavitve omrežja.
        <br/>
        Ime in geslo Wifi omrežja lahko vsebujeta znake
        <span style="word-break: break-word">
          ABCDEFGHIJKLMNOPQRSTUVWZXYabcdefghijklmnopqrstuvwzxy0123456789_-.
        </span>
      </p>
    </div>
    <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
      Za urejanje nastavitev brezžičnega omrežja, prosimo priklopite napravo v omrežje.
    </div>
    <div>
      <div v-loading="nalaganjeWifiPodatkov" style="padding-top: 25px" v-if="wifiNetworkGroups.length !== 0">
        <div>
          <el-collapse v-model="selectedNetwork" accordion>
            <el-collapse-item
              :title="group.name"
              :name="index" v-for="(group, index) in wifiNetworkGroups"
              :key="index"
              class="kljuc">
              <el-form
                :label-position="formaOrientacija"
                :key="key"
                v-for="[key] of Object.entries(group.networks[0])"
                label-width="250px"
                class="nova-vrstica-forma">
                <el-form-item :label="`Ime omrežja ${group.name}`" v-if="key === 'SSID'">
                  <el-input placeholder="" v-model="group.networks[0][key]" class="velikost-input"/>
                </el-form-item>
                <el-form-item label="Ključ" v-if="key === 'PSK'">
                  <el-input
                    type="password"
                    v-model="group.networks[0][key]"
                    :class="PasswordValid(group.networks[0][key]) ? 'velikost-input' : 'velikost-input error'"
                    value="FakePSW"
                    :id="`input-kljuc-${index}`">
                    <i slot="suffix"
                       :class="prikazeIkonoKljuc ? 'fa fa-eye ikonaEyeKljuc' : 'fa fa-eye-slash ikonaEyeSlashKljuc'"
                       @click="PrikazKljuca(`input-kljuc-${index}`)">
                    </i>
                  </el-input>
                  <i class="el-icon-warning">
                    <small>
                      Ključ mora vsebovati med 8 in 32 znakov.
                    </small>
                  </i>
                  <i class="el-icon-error" v-if="!PasswordValid(group.networks[0][key])">
                    <small>
                      Prosimo, vnesite med 8 in 32 znakov.
                      Uporabite lahko: ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxy0123456789_-.
                    </small>
                  </i>
                </el-form-item>
                <el-form-item
                  :label="`Omogoči ${group.name}`"
                  class="mobile-kljukica checkbox-mobile"
                  v-if="key === 'enabled'">
                  <el-checkbox style="margin-left: 6px" v-model="group.networks[0][key]" class="velikost-input"/>
                </el-form-item>
              </el-form>
              <div style="padding-top: 30px">
                <el-button
                  type="primary"
                  :disabled="!PasswordValid(group.networks[0].PSK)"
                  @click="PosodobiMultipleWifiConfig(group.networks[0], group.callValue)"
                  class="gumb-potrdi">
                  SHRANI SPREMEMBE
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div v-else>
        <p>
          Wifi ni podprt za ta tip naprave
        </p>
      </div>
      <div>
        <InfoKomponentaMreznaOprema/>
      </div>
      <div style="padding-top: 40px">
        <hr class="hr-stil">
      </div>
      <div style="padding-top: 40px">
        <LegendaBrezzicnoOmrezje/>
      </div>
    </div>
  </div>
</template>
<script>
import {Checkbox, Input, Button, Form, FormItem, Select, Option, Collapse, CollapseItem} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import InfoKomponentaMreznaOprema from './InfoKomponentaMreznaOprema'
import LegendaBrezzicnoOmrezje from './LegendaBrezzicnoOmrezje'

export default {
  name: 'MultipleWifiNetworks',
  mixins: [PrikazVsebine],
  props: {
    idIzbranaOprema: {},
    povezanoVOmrezje: false
  },
  emits: ['successNotification'],
  data () {
    return {
      title: 'Wifi',
      clientAgent: null,
      wifiNetworkGroups: [],
      formaOrientacija: 'left',
      nalaganjeWifiPodatkov: false,
      prikazeIkonoKljuc: false,
      selectedNetwork: [0]
    }
  },
  watch: {
    idIzbranaOprema: function () {
      if (this.idIzbranaOprema !== null) {
        this.GetMultipleWifiConfig()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetMultipleWifiConfig()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  components: {
    LegendaBrezzicnoOmrezje,
    InfoKomponentaMreznaOprema,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  methods: {
    PasswordValid (password) {
      return /^[A-Za-z0-9_-]{8,32}$/.test(password)
    },
    PrikazKljuca (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        this.prikazeIkonoKljuc = true
      } else {
        element.type = 'password'
        this.prikazeIkonoKljuc = false
      }
    },
    GetMultipleWifiConfig () {
      if (typeof this.idIzbranaOprema !== 'undefined') {
        this.nalaganjeWifiPodatkov = true
        let param = ['idOprema=' + this.idIzbranaOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/wifi/infoMultipleNetworks',
          param,
          param,
          'SetWifiInfo',
          'ShowErrorMsg')
      }
    },
    SetWifiInfo (podatki) {
      let wifiNetworkGroupTmp = []
      podatki.data.forEach(wifiNetworkGroup => {
        wifiNetworkGroupTmp.push(wifiNetworkGroup)
      })
      wifiNetworkGroupTmp.forEach(networkGroup => {
        networkGroup.networks.forEach(network => {
          network['enabled'] = network.Enabled === 'true'
        })
      })
      this.wifiNetworkGroups = wifiNetworkGroupTmp
      this.nalaganjeWifiPodatkov = false
    },
    async PosodobiMultipleWifiConfig (wifiNetwork, callValue) {
      this.nalaganjeWifiPodatkov = true
      let param = ['idOprema=' + this.idIzbranaOprema]
      param.push('callValue=' + encodeURI(callValue))
      param.push('ssid=' + encodeURI(wifiNetwork.SSID))
      param.push('password=' + encodeURI(wifiNetwork.PSK))
      param.push('wifiEnable=' + encodeURI(wifiNetwork.enabled))
      this.clientAgent.postWsRequest(
        this,
        'tr069/wifi/configure',
        param,
        null,
        'SetPosodobiWifiPodatke',
        'ErrPosodobiWifiPodatke')
    },
    SetPosodobiWifiPodatke () {
      this.$emit('successNotification')
      this.nalaganjeWifiPodatkov = false
    },
    ErrPosodobiWifiPodatke () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Prišlo je do napake pri spremembi brezžičnega omrežja.'
      this.ShowErrorMessage(paramObvestilo)
      this.GetMultipleWifiConfig()
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/wifi.css">
/deep/ .el-collapse-item .el-collapse-item__header:hover,
/deep/ .el-collapse-item .el-collapse-item__header:active,
/deep/ .el-collapse-item .el-collapse-item__header:focus {
  color:#f58220;
}
</style>
<style>
@media only screen and (max-width: 730px) {
  .mobile-kljukica.checkbox-mobile .el-form-item__content {
    width: unset !important;
  }
  .kljuc .el-icon-error {
    align-items: self-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/MultipleWifiNetworks.vue